import './App.css';
import DynamicPortfolio from './DynamicPortfolio';

function App() {
  return <DynamicPortfolio />;
}

export default App;

